// extracted by mini-css-extract-plugin
export default {"image":"S3ImageDisplay_image__UHu8I","imageRounded":"S3ImageDisplay_imageRounded__5tEn+ S3ImageDisplay_image__UHu8I"};